module.exports = __webpack_public_path__ + "media/images/icon__community@2x-50ba6d8d9c3680e6f5af956fb3976f30.png";